import requests from '../../request'

const ContentTypeEnum = {
  JSON: 'application/json;charset=UTF-8',
}

const baseUrl = '/scm/inbound'

/** 供应链订单列表 */
export function queryWholesaleOrder(data) {
  return requests(
    {
      url: baseUrl + '/wholesale/order/query',
      data,
      method: 'post',
    },
    {
      contentType: ContentTypeEnum.JSON,
    },
  )
}

/** 订单状态数量 */
export function statusCount() {
  return requests({
    url: baseUrl + '/wholesale/order/status-count',
    method: 'get',
  })
}

/** 订单详情 */
export function getWholesaleOrder(id) {
  return requests({
    url: baseUrl + '/wholesale/order',
    params: { id },
    method: 'get',
  })
}

/** 拉单商品明细 */
export function getWholesaleOrderProducts(params) {
  return requests({
    url: baseUrl + '/wholesale/order/products',
    params,
    method: 'get',
  })
}

/** 发起入库 */
export function pullScmInbound(data) {
  return requests(
    {
      url: baseUrl + '/pull',
      data,
      method: 'post',
    },
    {
      contentType: ContentTypeEnum.JSON,
    },
  )
}
